module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/_babel-runtime@6.25.0@babel-runtime/core-js/is-iterable.js
// module id = 141
// module chunks = 20